import { MediaEntry } from './MediaEntry'

export default MediaEntry
